import classNames from "classnames";
import styles from "./confirm-button.module.css";
import tracking from "frontend/tracking";

export default function ConfirmButton({
  onClick,
  title,
  disabled,
  isLoading,
  trackingEventName,
}: {
  onClick: () => void;
  title: string;
  disabled?: boolean;
  isLoading?: boolean;
  trackingEventName: string;
}) {
  return (
    <button
      className={classNames(styles.confirmButton, { [styles.loading]: isLoading })}
      disabled={disabled || isLoading}
      onClick={() => {
        onClick();
        tracking.trackAnalyticsEvent(trackingEventName);
      }}
    >
      {title}
    </button>
  );
}
